import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function householdToolBoxIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M6 5.333h4V4H6zm-4 8a.65.65 0 0 1-.475-.191.65.65 0 0 1-.192-.475V10H4q0 .283.192.475a.65.65 0 0 0 .475.192.65.65 0 0 0 .475-.192.65.65 0 0 0 .191-.475h5.334q0 .283.191.475a.65.65 0 0 0 .475.192.65.65 0 0 0 .475-.192A.65.65 0 0 0 12 10h2.667v2.667a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191zm-.667-4V6.667q0-.55.392-.942t.942-.392h2V4q0-.55.391-.942.392-.39.942-.391h4q.55 0 .942.391.39.392.391.942v1.333h2q.55 0 .942.392.392.391.392.942v2.666H12v-.666a.65.65 0 0 0-.192-.475.65.65 0 0 0-.475-.192.65.65 0 0 0-.475.192.65.65 0 0 0-.191.475v.666H5.333v-.666a.65.65 0 0 0-.191-.475A.65.65 0 0 0 4.667 8a.65.65 0 0 0-.475.192.65.65 0 0 0-.192.475v.666z" fill="currentColor" />
    </BaseIcon>
  );
}
